import React, { useEffect, useState } from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import { getFractionalNFTFromContract, getFractionalNFTFromLocal, listActiveFractionalNFTs } from '../../../hooks/FNFThook';
import { useParams } from 'react-router-dom';

const styles = {
  card: {
    // backgroundColor: '#f3e6f6',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
  },
  description: {
    fontSize: '16px',
    color: '#666',
  },
  block: {
    // backgroundColor: '#f8f2fb',
    borderRadius: '10px',
    padding: '20px',
    border: '1px solid #dfdfdf',
    marginBottom: '20px',
  },
  iconButton: {
    border: 'none',
    backgroundColor: '#f8f2fb',
    borderRadius: '50%',
    padding: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    fontSize: '18px',
    color: '#888',
  },
  calendarContainer: {
    // backgroundColor: '#f8f2fb',
    borderRadius: '10px',
    padding: '10px',
  },
  imagePreview: {
    width: '100%',
    borderRadius: '12px',
  },
  calendarTileActive: {
    backgroundColor: '#7c2dff',
    color: 'white',
  },
  calendarTile: {
    backgroundColor: '#e7d2f9',
    borderRadius: '8px',
  },
};

const SearchPad = (props) => {
  const { id } = useParams();
  const [localFund, setLocalFund] = useState(null);
  const [contractFund, setContractFund] = useState({});

  useEffect(() => {
    NFTData()
  }, [id]);

  console.log("id", id);

  const NFTData = async () => {
    const DatafromContract = await getFractionalNFTFromContract(id);
    if (DatafromContract.status === 200) {
      setContractFund(DatafromContract.data)
    }
    console.log("id for Local Data", id);
    const params = {
      fractionNftId: id
    }
    const DatafromLocal = await listActiveFractionalNFTs(params);
    if (DatafromLocal.success) {
      setLocalFund(DatafromLocal.data)
    }
  }

  console.log("at IDO Overview => contractFund, localFund", id, contractFund, localFund);

  return (
    <div>
      {localFund !== null &&
        <>
          <Row className="">
            <Col md={4}>
              <Card style={styles.block}>
                <h5>Raise Info</h5>
                <p>Target Raise: {contractFund?.totalFundsDesired} ETH</p>
                <p>Actual Raise: {contractFund?.totalFundsRaised}</p>
              </Card>
            </Col>
            <Col md={4}>
              <Card style={styles.block}>
                <h5>Project Info</h5>
                <p>Funding Active: {localFund.isFundingActive ? "true" : "false"}</p>
                <p>Project Tokens on: DTOC</p>
                {/* <p>IDO Refund Window (days): -</p> */}
              </Card>
            </Col>
            <Col md={4}>
              <Card style={styles.block}>
                <h5>Re Sell NFTs</h5>
                <p>Price: {localFund.resellValueOfNft}</p>
              </Card>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col>
              <Card style={styles.block}>
                <h5>Rounds</h5>
                {/* Rounds content will go here */}
              </Card>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col md={6}>
              <Card style={styles.block}>
                <h5>Project Details</h5>
                <p>
                  {localFund?.campaignDescription}
                </p>
              </Card>
            </Col>
            <Col md={6}>
              <Card style={styles.block}>
                <h5>Token Metrics</h5>
                <p>Initial Supply: 730,000,000</p>
                <p>Total Supply: {contractFund?.totalTokenSupplied}/{localFund?.fractionalTokenSupply}</p>
                <p>Symbol: {localFund?.fractionalTokenSymbol}</p>
                <p>Blockchain: ethereum</p>
              </Card>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col>
              <Card style={styles.calendarContainer}>
                <h5>Calendar</h5>
                {/* <Calendar
                onChange={setDate}
                value={date}
                tileClassName={({ activeStartDate, date, view }) =>
                  date.getDate() === new Date().getDate() ? 'calendar-tile-active' : ''
                }
                calendarType="US"
              /> */}
              </Card>
            </Col>
          </Row>
        </>
      }
    </div>
  );
};

export default SearchPad;
